/**
 * @generated SignedSource<<a8966b97fca5909044db3f0f31eb0cc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScheduleDayOfMonth = "FIRST_WORKING_DAY" | "LAST_WORKING_DAY" | "DAY_1" | "DAY_15" | "LAST_DAY" | "FIRST_MONDAY" | "LAST_FRIDAY" | "%future added value";
export type ScheduleFrequency = "WEEKLY" | "BIWEEKLY" | "FOUR_WEEKLY" | "MONTHLY" | "QUARTERLY" | "%future added value";
export type ScheduleWeekday = "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY" | "%future added value";
export type UpdateScheduleInput = {
  consumer: string;
  scheduleId: string;
  frequency?: ScheduleFrequency | null;
  dayOfMonth?: ScheduleDayOfMonth | null;
  weekdays?: ReadonlyArray<ScheduleWeekday> | null;
  timeOfDay?: string | null;
  timezone?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type scheduleMutationsUpdateMutation$variables = {
  input: UpdateScheduleInput;
};
export type scheduleMutationsUpdateMutation$data = {
  readonly updateSchedule: {
    readonly scheduleSet: {
      readonly id: string;
      readonly consumer: string;
      readonly enabled: boolean;
      readonly schedules: ReadonlyArray<{
        readonly id: string;
        readonly scheduleId: string;
        readonly frequency: ScheduleFrequency;
        readonly dayOfMonth: ScheduleDayOfMonth | null;
        readonly weekdays: ReadonlyArray<ScheduleWeekday>;
        readonly timeOfDay: string;
        readonly timezone: string;
      }>;
    } | null;
  } | null;
};
export type scheduleMutationsUpdateMutation = {
  variables: scheduleMutationsUpdateMutation$variables;
  response: scheduleMutationsUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSchedulePayload",
    "kind": "LinkedField",
    "name": "updateSchedule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleSet",
        "kind": "LinkedField",
        "name": "scheduleSet",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consumer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedules",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frequency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dayOfMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekdays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeOfDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "scheduleMutationsUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "scheduleMutationsUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "545929f6271f4e39830a8a170e9c6401",
    "id": null,
    "metadata": {},
    "name": "scheduleMutationsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation scheduleMutationsUpdateMutation(\n  $input: UpdateScheduleInput!\n) {\n  updateSchedule(input: $input) {\n    scheduleSet {\n      id\n      consumer\n      enabled\n      schedules {\n        id\n        scheduleId\n        frequency\n        dayOfMonth\n        weekdays\n        timeOfDay\n        timezone\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ece673a942f6da37c5ca9eebc46ae383";

export default node;
